import { AcaoNotaFiscalSaidaEnum } from '@shared/enums/vendas/acao-nota-fiscal-saida.enum';

/** Item do menu de contexto da nota fiscal de saída, já resolvido para a linha; a primeira ação é a principal. */
export class AcaoNotaFiscalSaidaStruct {
  public acao: AcaoNotaFiscalSaidaEnum;
  public rotulo: string;
  public icone: string;
  public isDisponivel: boolean;
  /** Motivo exibido em tooltip quando a ação está indisponível. */
  public motivoIndisponivel: string;
}
